import React, {useEffect, useState} from 'react';
import {ObservationCard} from "./observation-card";
import {EBirdMyDataSchema} from "ebird-mydata-reader";
import {formatDate} from "../helpers/helpers";
import {DateTime} from "luxon";

export type InfoboxLocationDetailProps = {
    observations?: any[],
    year?: number | string
    month?: number | string
}

export function InfoboxLocationDetail({observations, year, month}: InfoboxLocationDetailProps) {

    const [title, setTitle] = useState('');

    const getBadges = (observation: EBirdMyDataSchema) => {
        const badges = [];
        if (observation.isLifer) badges.push('Lifer');
        else if (observation.isFirstOfYear) badges.push('First of Year');
        return badges;
    }

    useEffect(() => {
        if (observations?.length) {
            const location = observations[0].location;
            let title = `Species for ${location}`;
            if (year && !isNaN(parseInt(year as string))) {
                if (month && year !== 'life') {
                    const date = DateTime.local(parseInt(year as string), parseInt(month as string), 1);
                    title = `${date.toLocaleString({ month: 'long', year: 'numeric'})} Species for ${location}`
                } else if (year !== 'life') {
                    title = `${year} Species for ${location}`
                }
            }

            setTitle(title);
        }
    }, [observations, month, year]);

    return (
        <>
            {title ?
                <h2 className="infobox__title">
                    {title}
                </h2>
                : null
            }

            <div className="infobox__body">
            {observations?.map((obs, i) => (
                    <ObservationCard
                        key={i}
                        image={obs.image}
                        kicker={`${i + 1}. ${obs.commonName}`}
                        copy={
                            <>
                                {formatDate(obs.date)}<br/>
                                {obs.time},
                                Count: {obs.count}
                            </>
                        }
                        badges={getBadges(obs)}
                    />
                ))}
            </div>
        </>
    )
}
